import {makeEnumTypeGuard} from '../../../../../libs/shared/helpers/src/typescript/enumHelpers';
import {hasProperty} from '../../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {WorkspaceFolderNestedLabelsEnum} from '../../../../models/api/workspaceModel';

export type WorkspaceItemDropHandler = (
  droppedItem: WorkspaceDragItem,
  position: DropLinePositionsEnum,
  targetItem?: WorkspaceDragItem,
  skipError?: boolean,
) => void;

export enum WorkspaceDragSourceTypesEnum {
  ASSIGNED_TEAMMATE = 'ASSIGNED_TEAMMATE',
  DELEGATION = 'DELEGATION',
  PERSONAL_VIEW = 'PERSONAL_VIEW',
  PERSONAL_FOLDER = 'PERSONAL_FOLDER',
  TEAM_VIEW = 'TEAM_VIEW',
  TEAM_INBOX = 'TEAM_INBOX',
  LENS = 'LENS',
}

export const isWorkspaceDragSourceTypeEnum = makeEnumTypeGuard(WorkspaceDragSourceTypesEnum);

export function isWorkspaceDragItem(blob: any): blob is WorkspaceDragItem {
  return hasProperty(blob, 'type') && isWorkspaceDragSourceTypeEnum(blob.type);
}

interface WorkspaceAssignedTeammateDragItem {
  id: number;
  type: WorkspaceDragSourceTypesEnum.ASSIGNED_TEAMMATE;
  isLast: boolean;
}

interface WorkspaceDelegationDragItem {
  id: number;
  type: WorkspaceDragSourceTypesEnum.DELEGATION;
}

export interface WorkspacePersonalCustomViewDragItem {
  id: number;
  type: WorkspaceDragSourceTypesEnum.PERSONAL_VIEW;
  namespace: string;
  nestingLevel: number;
  hasExpandedChildren: boolean;
  isLast: boolean;
}

export interface WorkspacePersonalWorkspaceDragItem {
  type: WorkspaceDragSourceTypesEnum.PERSONAL_FOLDER;
  isLast: boolean;
  id:
    | number
    | WorkspaceFolderNestedLabelsEnum.ASSIGNED_TO_ME
    | WorkspaceFolderNestedLabelsEnum.SHARED_WITH_ME
    | WorkspaceFolderNestedLabelsEnum.DISCUSSIONS;
}

interface WorkspaceTeamCustomViewDragItem {
  id: number;
  type: WorkspaceDragSourceTypesEnum.TEAM_VIEW;
  hasExpandedChildren: boolean;
  nestingLevel: number;
  namespace: string;
  isLast: boolean;
}

interface WorkspaceTeamLensDragItem {
  id: number;
  type: WorkspaceDragSourceTypesEnum.LENS;
  isLast: boolean;
}

interface WorkspaceTeamInboxDragItem {
  id: number;
  type: WorkspaceDragSourceTypesEnum.TEAM_INBOX;
  namespace: string;
  isLast: boolean;
}

export type WorkspaceDragItem =
  | WorkspaceAssignedTeammateDragItem
  | WorkspaceDelegationDragItem
  | WorkspacePersonalCustomViewDragItem
  | WorkspacePersonalWorkspaceDragItem
  | WorkspaceTeamCustomViewDragItem
  | WorkspaceTeamLensDragItem
  | WorkspaceTeamInboxDragItem;

export enum DropLinePositionsEnum {
  ABOVE = 'ABOVE',
  BELOW = 'BELOW',
  NONE = 'NONE',
}
